<p-dialog [(visible)]="display" [modal]="true" [responsive]="true" [style]="{ width: '80vw' }" (onHide)="onCancel()">
    <ng-template pTemplate="header">
        <div class="p-d-flex p-jc-between p-ai-center" style="width: 100%">
            <h5 class="p-mb-0">Sales Receipt Details</h5>
            <div class="p-d-flex p-ai-center gap-2">
                <i class="pi pi-pencil p-pr-1" pTooltip="Edit Sales Receipt" tooltipPosition="top" (click)="editSalesReceipt()" style="cursor: pointer"></i>
                <button type="button" (click)="salesReceiptPrint()" pButton label="Print"></button>
            </div>
        </div>
    </ng-template>
    <div class="p-grid">
        <!-- Left Side: First Half -->
        <div class="p-col-12 p-md-6">
            <div class="card" style="min-height: 135px">
                <h6 class="p-mb-0">Account Information</h6>
                <ng-container *ngFor="let item of accountinfo; let i = index">
                    <p class="p-mb-0" *ngIf="i < accountinfo.length / 2">
                        <strong>{{ item.header }}:</strong>
                        <ng-container *ngIf="item.datatype === 'DateTime'; else normalValue">
                            {{ item.value | date: "dd/MM/yyyy" }}
                        </ng-container>

                        <ng-template #normalValue>
                            <ng-container *ngIf="item.header === 'Account Name'; else plainText">
                              <span style="cursor: pointer; color: #517fa4;" (click)="onAccountNameClick(item)">
                                {{ item.value }}
                              </span>
                            </ng-container>
                            <ng-template #plainText>
                              {{ item.value }}
                            </ng-template>
                          </ng-template>
                    </p>
                </ng-container>
                <p class="p-mb-0">
                    <strong>Total Paid Amount:</strong>
                    {{ this.invoicingDetails?.totalReceivedAmount | customNumberFormat: fractionDigits | currencySymbol }}
                </p>
            </div>
        </div>
        <!-- Right Side: Second Half -->
        <!-- <div class="p-col-12 p-md-6">
            <div class="card" style="min-height: 135px;">
                <ng-container *ngFor="let item of accountinfo; let i = index">
                    <p class="p-mb-0" *ngIf="i >= (accountinfo.length / 2)">
                        <strong>{{ item.header }}:</strong>
                        <ng-container *ngIf="item.datatype === 'DateTime'; else normalValue">
                            {{ item.value | date: 'dd/MM/yyyy' }}
                        </ng-container>

                        <ng-template #normalValue>
                            {{ item.value }}
                        </ng-template>
                    </p>
                </ng-container>

            </div>
        </div> -->
        <div class="p-col-12 p-md-6" *ngIf="customAtributes?.labels_misc?.length">
            <div class="card" style="min-height: 135px">
                <p style="font-weight: 600; color: #2c2c2c">{{ customAtributes.labels_misc[0]?.section?.name }} :</p>
                <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customAtributes.labels_misc"></app-custom-attribute-overview>
            </div>
        </div>
    </div>
    <div class="p-field p-formgrid p-grid">
        <div class="p-col-12">
            <!-- <p-table [columns]="estimatesCols2" [value]="salesReceiptsByIdList" styleClass="p-datatable-gridlines"
                [resizableColumns]="true" [scrollable]="true" [style]="{ width: '100%' }" [resizableColumns]="true"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                styleClass="p-datatable-gridlines" [resizableColumns]="true">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <ng-container *ngFor="let col of columns">
                            <th *ngIf="col.show" style="border-right: 1px solid var(--primary-color)" pResizableColumn>
                                {{ col.header }}
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                        <ng-container *ngFor="let col of columns">
                            <td *ngIf="col.show && col.datatype != 'DateTime' && col.datatype != 'Decimal'">{{
                                rowData[col.field] }}
                            </td>
                            <td *ngIf="col.show && col.datatype == 'Decimal'">{{ rowData[col.field] | customNumberFormat:fractionDigits |currencySymbol}}</td>
                            <td *ngIf="col.show && col.datatype == 'DateTime'">{{ rowData[col.field] | date:
                                "MM/dd/yyyy" }}</td>
                        </ng-container>
                    </tr>
                </ng-template>
            </p-table> -->
            <p-table [value]="InvoiceTB">
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngIf="salesReceiptsTemplate?.labels_table[0]?.isChecked">{{ salesReceiptsTemplate?.labels_table[0]?.labelname }}</th>
                        <th *ngIf="salesReceiptsTemplate?.labels_table[1]?.isChecked">{{ moduleName[channelName] }} {{ salesReceiptsTemplate?.labels_table[1]?.labelname }}</th>
                        <th *ngIf="salesReceiptsTemplate?.labels_table[2]?.isChecked">{{ moduleName[channelName] }} {{ salesReceiptsTemplate?.labels_table[2]?.labelname }}</th>
                        <th *ngIf="salesReceiptsTemplate?.labels_table[3]?.isChecked">{{ moduleName[channelName] }} {{ salesReceiptsTemplate?.labels_table[3]?.labelname }}</th>
                        <th>Paid Amount</th>
                        <!-- <th *ngIf="salesReceiptsTemplate?.labels_table[4]?.isChecked">{{ moduleName[channelName] }} {{ salesReceiptsTemplate?.labels_table[4]?.labelname }}</th> -->
                        <th>Credit</th>
                        <th *ngIf="salesReceiptsTemplate?.labels_table[5]?.isChecked">{{ salesReceiptsTemplate?.labels_table[5]?.labelname }}</th>
                        <th *ngIf="salesReceiptsTemplate?.labels_table[6]?.isChecked">{{ salesReceiptsTemplate?.labels_table[6]?.labelname }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr [pSelectableRow]="product">
                        <td *ngIf="salesReceiptsTemplate?.labels_table[0]?.isChecked">{{ product.dueDate | date: "MM/dd/yyyy" }}</td>
                        <td *ngIf="salesReceiptsTemplate?.labels_table[1]?.isChecked" style="cursor: pointer; color: #517fa4;" (click)="showInventoryDialog(product?.invoice)">{{ product.invoiceNo ? product.invoiceNo : null }}</td>
                        <td *ngIf="salesReceiptsTemplate?.labels_table[2]?.isChecked">{{ product.invoiceAmount ? (product.invoiceAmount | customNumberFormat: fractionDigits | currencySymbol) : null }}</td>
                        <td *ngIf="salesReceiptsTemplate?.labels_table[3]?.isChecked">{{ product?.currencyCode ?? this.baseCurrency?.symbol }}{{ (product.invoiceAmount || 0) * (product.exchangeRate || 1) | customNumberFormat: fractionDigits }}</td>
                        <td>
                            {{ product.totalPaidAmount ? (product.totalPaidAmount | customNumberFormat: fractionDigits | currencySymbol) : null }}
                        </td>
                        <!-- <td *ngIf="salesReceiptsTemplate?.labels_table[4]?.isChecked">{{ product.actualDueAmount ? (product.actualDueAmount | customNumberFormat: fractionDigits | currencySymbol) : null }} </td> -->
                        <td>
                            <span>{{ product.credit | customNumberFormat: fractionDigits | currencySymbol }}</span>
                        </td>
                        <td class="action" *ngIf="salesReceiptsTemplate?.labels_table[5]?.isChecked">
                            <span>{{ product.amountApplied | customNumberFormat: fractionDigits | currencySymbol }}</span>
                        </td>
                        <td *ngIf="salesReceiptsTemplate?.labels_table[6]?.isChecked">{{ product.amountDue | customNumberFormat: fractionDigits | currencySymbol }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <div class="p-col-12" *ngIf="memo">
        <div class="card" style="min-height: 20px">
            <p style="font-weight: 600; color: #2c2c2c">Memo :</p>
            <p>{{ memo }}</p>
        </div>
    </div>
    <div class="p-col-12" *ngIf="customAtributes?.labels_message?.length > 0">
        <div class="card" style="min-height: 135px">
            <p style="font-weight: 600; color: #2c2c2c">{{ customAtributes.labels_message[0]?.section?.name }} :</p>
            <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customAtributes.labels_message"> </app-custom-attribute-overview>
        </div>
    </div>

    <div class="p-col-12" *ngIf="customAtributes?.other1_item?.length > 0">
        <div class="card" style="min-height: 135px">
            <p style="font-weight: 600; color: #2c2c2c">{{ customAtributes.other1_item[0]?.section?.name }} :</p>
            <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customAtributes.other1_item"> </app-custom-attribute-overview>
        </div>
    </div>

    <div class="p-col-12" *ngIf="customAtributes?.other2_item?.length > 0">
        <div class="card" style="min-height: 135px">
            <p style="font-weight: 600; color: #2c2c2c">{{ customAtributes.other2_item[0]?.section?.name }} :</p>
            <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customAtributes.other2_item"> </app-custom-attribute-overview>
        </div>
    </div>

    <div class="p-col-12" *ngIf="customAtributes?.other3_item?.length > 0">
        <div class="card" style="min-height: 135px">
            <p style="font-weight: 600; color: #2c2c2c">{{ customAtributes.other3_item[0]?.section?.name }} :</p>
            <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customAtributes.other3_item"> </app-custom-attribute-overview>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton label="Cancel" (click)="onCancel()" class="p-button-secondary"></button>
    </ng-template>
</p-dialog>
<app-sales-receipt-pdf [estimatesCols2]="estimatesCols2" [channelName]="channelName" [soChannel]="soChannel" [companyInfo]="companyInfo" [receivedPaymentId]="receivedPaymentId" [selectedRowData]="selectedRowData"   [fractionDigits]="fractionDigits" [salesReceiptsTemplate]="salesReceiptsTemplate" [salesReceiptsByIdList]="salesReceiptsByIdList"></app-sales-receipt-pdf>

<app-inventory-module-overview-dialogs *ngIf="displayInventoryOverview" [displayOverview]="displayInventoryOverview"
    [overviewRefId]="inventoryOverviewRefId" [overviewRefNumber]="inventoryOverviewRefNumber" [isShowVoidDelete]="true"
    [trackingOptions]="trackingOptions" [selectedBillTransRow]="selectedTransRow" [poEdit]="true"
    [visibleFromModule]="'Finance'" [overviewModule]="inventoryOverviewModule" (onCancel)="closeViewPopup()"
    >
</app-inventory-module-overview-dialogs>

<app-edit-account *ngIf="displayAccountViewEdit" [displayEditViewDialog]="displayAccountViewEdit" [displayView]="true"
    [selectedAccountId]="selectedAccountId" [selectedChannelId]="selectedAccountChannelId"
    (closeModal)="closeAccountViewEditModal()">
</app-edit-account>
<!-- (onEdit)="openEditPopup()" -->